import React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import Loader from "../Loader";

const ChannelToggles = ({ config, prefix, onToggle }) => {
  const fields = [
    { key: `${prefix}sms_enabled`, label: "SMS" },
    { key: `${prefix}app_enabled`, label: "App" },
    { key: `${prefix}email_enabled`, label: "Email" },
  ];

  return (
    <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
      {fields.map(({ key, label }) => (
        <FormControlLabel
          key={key}
          control={
            <Switch
              checked={config?.[key] ?? true}
              onChange={(e) => onToggle(key, e.target.checked)}
              color="primary"
            />
          }
          label={label}
        />
      ))}
    </Box>
  );
};

const GeneralNotificationChannels = ({ config, isLoading, isSessionBased, onToggle }) => {
  if (isLoading) return <Loader />;

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        Non-Visit Notifications (Retake Photos, Retake Video, Retake Survey, Reupload App Document,
        Visit Reopened)
      </Typography>
      <ChannelToggles config={config} prefix="" onToggle={onToggle} />

      {!isSessionBased && (
        <>
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
            Visit Complete Notification
          </Typography>
          <ChannelToggles config={config} prefix="visit_complete_" onToggle={onToggle} />
        </>
      )}
    </Box>
  );
};

export default GeneralNotificationChannels;
